import React, { useEffect, useState } from 'react';
import { Observer } from 'mobx-react';
import {
  Card,
  Grid,
  CardHeader,
  CardContent,
  Divider,
} from '@material-ui/core';
import { HorizontalBar } from 'react-chartjs-2';
import { toJS } from 'mobx';
import Spinner from '../../util/Spinner';
import { useRootStore } from '../../../stores/BridgeProvider';
import { COLORS } from '../../util/Colors';

const TopAgents = () => {
  const [loading, setLoading] = useState(true);
  const { orgStore } = useRootStore();
  const agents = orgStore.topAgents;
  const { settings } = orgStore;
  const { ExtSysId } = settings;
  const isIntegrated = ExtSysId > 0;

  useEffect(() => {
    const getTopAgents = async () => {
      await orgStore.retrieveTopAgents();
      setLoading(false);
    };
    getTopAgents();
  }, []);

  const options = {
    scales: {
      xAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback(value) {
              return `$${value
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
            },
          },
        },
      ],
    },
  };
  const data = () => {
    if (!loading)
      return {
        labels: agents.map(a => a.AgentName),
        datasets: [
          {
            label: 'YTD Income',
            backgroundColor: 'rgba(255,99,132,0.2)',
            borderColor: COLORS.red,
            borderWidth: 1,
            hoverBackgroundColor: 'rgba(255,99,132,0.4)',
            hoverBorderColor: 'rgba(255,99,132,1)',
            data: agents.map(a => a.IncomeAmount),
          },
        ],
      };
  };

  if (loading) return <Spinner />;

  const graphHeight = Math.max(100, agents.length * 15);
  return (
    <Card style={{ height: '100%', width: '50%' }}>
      <CardHeader title="Top Performing Agents" />
      <Divider />
      <CardContent style={{ padding: '10px' }}>
        {!loading && agents && (
          <HorizontalBar height={graphHeight} data={data} options={options} />
        )}
        {!loading && !agents && (
          <div
            style={{
              display: 'flex',
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h4>No agent data</h4>
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TopAgents;
